import { FormControlLabel, FormHelperText, Switch } from "@mui/material";
import { FormControl } from "./index";
import PropTypes from "prop-types";

const ToggleBox = props => {
  const {
    name,
    label,
    variant,
    value,
    required,
    fullWidth,
    helperText,
    disabled
  } = props;

  return (
    <FormControl
      key={`key${name}`}
      error={helperText ? true : false}
      fullWidth={fullWidth}
    >

      <FormControlLabel
        control={
          <Switch
            required={required}
            disabled={disabled}
            color={variant}
            checked={value ? true : false}
            onChange={e => props.onChange(e.target.checked)}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
        label={label}
      />

      {helperText &&
        <FormHelperText>
          {helperText}
        </FormHelperText>}
    </FormControl>
  );
};

ToggleBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  variant: PropTypes.string,
  options: PropTypes.string,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
}

export default ToggleBox;
